/*
 * Abo-Sichtbarkeit pro Variante
 * --------------------------------
 * Blendet die Abo-Blöcke (.abo-wrap[data-abo]) in main-product--default
 * je nach gewählter Variante ein/aus.
 * Sichtbar = Variante hat Selling Plans (Recharge) UND Varianten-Metafeld
 * custom.abo_ausblenden ist nicht aktiv. Die Map kommt fertig aus Liquid.
 * Wird das Abo für eine Variante ausgeblendet, während ein Abo-Regler an ist,
 * wird er ausgeschaltet, damit kein unsichtbares Abo im Warenkorb landet.
 * (Seit Abo-Box-Redesign: alle Regler im Bereich, nicht nur der erste.)
 */
(function () {
  if (customElements.get('abo-visibility')) return;

  var VARIANT_EVENTS = ['product:variant-change', 'variant:changed', 'variantChange'];

  class AboVisibility extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      try {
        var raw = this.querySelector('[data-abo-map]');
        this._map = raw ? JSON.parse(raw.textContent) : {};
      } catch (e) {
        this._map = {};
      }

      this._area = this.closest('.add-to-cart-area') || this.parentElement;
      this._form = document.getElementById(this.dataset.formId);
      this._scope = this.closest('.shopify-section') || document;
      this._lastId = null;

      var self = this;
      this._schedule = function () {
        // Theme setzt den Varianten-Wert teils asynchron → mehrfach nachsehen
        self.update();
        setTimeout(function () { self.update(); }, 60);
        setTimeout(function () { self.update(); }, 300);
      };

      this._scope.addEventListener('change', this._schedule);
      this._scope.addEventListener('click', this._schedule);
      VARIANT_EVENTS.forEach(function (name) {
        document.addEventListener(name, self._schedule);
      });
      window.addEventListener('popstate', this._schedule);

      this.update();
    }

    disconnectedCallback() {
      var self = this;
      this._scope.removeEventListener('change', this._schedule);
      this._scope.removeEventListener('click', this._schedule);
      VARIANT_EVENTS.forEach(function (name) {
        document.removeEventListener(name, self._schedule);
      });
      window.removeEventListener('popstate', this._schedule);
      this._init = false;
    }

    currentVariantId() {
      var field = this._form && this._form.querySelector('[name="id"]');
      if (field && field.value) return String(field.value);
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      return fromUrl ? String(fromUrl) : null;
    }

    update() {
      var id = this.currentVariantId();
      if (!id || id === this._lastId) return;
      this._lastId = id;

      var show = this._map[id] === true;
      var wraps = this._area.querySelectorAll('.abo-wrap[data-abo]');
      wraps.forEach(function (el) { el.hidden = !show; });

      if (!show) {
        this._area.querySelectorAll('[js-subcription-selection]').forEach(function (toggle) {
          if (toggle.checked) {
            toggle.checked = false;
            toggle.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }
  }

  customElements.define('abo-visibility', AboVisibility);
})();
